<!--测温看板中，中间设备列表和信息-->
<template>
	<div class=" unitInfoBody bodyBorder" style="height: 800px;">
		<div class="topLeftTitleContent">设备监测</div>
		<div class="unitContent">
			<div class="bodyBorder flexStart" style="height: 30px;border-width: 0 0 1px 0;position: relative;">
				<p :class="['topLeftTitleContent', 'device-type',{'uncheck':nowCheck != 1}]" @click="nowCheckChange(1)" title="手动添加到监测列表的设备">重点监测</p>
				<p :class="['topLeftTitleContent', 'device-type',{'uncheck':nowCheck != 0}]" @click="nowCheckChange(0)" title="3天内产生过事件的设备">异常设备</p>
				<p style="margin-right: 20px;position: absolute;right: 0;cursor: pointer;" v-if="nowCheck == 1" @click="addFocus">添加设备</p>
			</div>
			<div id="carouselContainer" class="custom-scrollbar deviceLineBox" style="height: 290px;">
				<div class="powerBoxLi" v-for="item in deviceList" v-if="nowCheck == 0" @click="nowDevice = item">
					<div class="topLeftTitleContent" style="position: relative;">{{item.name}}
						<div class="colorCircle" :style="getDeviceState(item.no)"></div>
						<img class="removeDevice" :src="$store.resourcesStore.getters.getResourcesByName('wedoButton/clean.png')" title="移除" @click="removeDevice(item)">
					</div>
					<div class="powerBoxTemp custom-scrollbar bodyBorder">
						<div v-for="variableGroup in getVariableTree(item.no)">
							<p class="variable-group">{{variableGroup.name}} ( {{variableGroup.unit}} )</p>
							<p :style="getVariableStyle(variable.fromName)" v-for="variable in variableGroup.next">{{variable.name.subByFirstChar('.')}} : {{getVariableText(variable.fromName)}}</p>
						</div>
					</div>
				</div>
				<div class="powerBoxLi" v-for="item in focusDeviceList" v-if="nowCheck == 1" @click="nowDevice = item">
					<div class="topLeftTitleContent" style="position: relative;">{{item.name}}
						<div class="colorCircle" :style="getDeviceState(item.no)"></div>
						<img class="removeDevice" :src="$store.resourcesStore.getters.getResourcesByName('wedoButton/clean.png')" title="移除" @click="removeDevice(item)">
					</div>
					<div class="powerBoxTemp custom-scrollbar bodyBorder">
						<div v-for="variableGroup in getVariableTree(item.no)">
							<p class="variable-group">{{variableGroup.name}} ( {{variableGroup.unit}} )</p>
							<p :style="getVariableStyle(variable.fromName)" v-for="variable in variableGroup.next">{{variable.name.subByFirstChar('.')}} : {{getVariableText(variable.fromName)}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bodyBorder flexStart" style="height: 30px;border-width: 0 0 1px 0;">
			<p v-for="variableGroup in getVariableTree(nowDevice.no)" :class="['topLeftTitleContent', 'device-type',{'uncheck':nowType.id != variableGroup.id}]" @click="nowType = variableGroup" title="监测点类型">{{variableGroup.name}}</p>
		</div>
		<vchart style="height: 400px;width: 100%;" ref='vchart'></vchart>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				deviceList: [],
				focusDeviceList: [],
				nowCheck: 1,
				options: {},
				nowDevice: {},
				nowType: {},
				from2name: {},
				historyDataList: []
			}
		},
		created() {},
		mounted() {
			debugPage = this
			//获取当前单位应该查看的设备列表
			addNewTask('refreshDeviceLineData', 0, 5 * 60 * 1000, -1, respon => {
				this.searchDeviceList()
				this.searchRel()
			})
			this.initChart()
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", this.nowAllVariableNames)
			removeTask('refreshDeviceLineData')
		},
		computed: {
			nowReadDeviceNoList() {
				return this.$store.deviceStore.getters.getReadDeviceNoList
			},
			readDeviceTree() {
				return this.$store.deviceStore.getters.getReadDeviceTree
			},
			getVariableTree() {
				return this.$store.variableStore.getters.getVariableTree
			},
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			nowAllVariableNames() {
				var list = []
				for(var i = 0, len = this.focusDeviceList.length; i < len; i++) {
					var item = this.focusDeviceList[i]
					var group = this.getVariableTree(item.no)
					for(var i1 = 0, len1 = group.length; i1 < len1; i1++) {
						list.addAll(group[i1].next)
					}
				}
				for(var i = 0, len = this.deviceList.length; i < len; i++) {
					var item = this.deviceList[i]
					var group = this.getVariableTree(item.no)
					for(var i1 = 0, len1 = group.length; i1 < len1; i1++) {
						list.addAll(group[i1].next)
					}
				}
				return list.map(item => item.fromName)
			},
			realTimeValueMap() {
				//获取值
				var vl = this.realTimeValueStore.getters.getValue(this.nowAllVariableNames)
				var deviceList = this.nowAllVariableNames.map(item => item.substring(0, item.indexOf('.'))).distinct()
				var deviceStateMap = this.realTimeValueStore.getters.getDeviceState(deviceList)
				var v2 = this.realTimeValueStore.getters.getTime(this.nowAllVariableNames)
				var map = {}
				for(var i = 0, len = this.nowAllVariableNames.length; i < len; i++) {
					var item = this.nowAllVariableNames[i]
					var value = vl[i]
					var text = this.realTimeValueStore.getters.getText(item, vl[i])
					var deviceState = '--'
					switch(deviceStateMap[item.substring(0, item.indexOf('.'))]) {
						case 0:
							deviceState = '中断'
							break
						case 1:
							deviceState = '正常'
							break
					}
					var time = v2[i] != undefined ? new Date(parseInt(v2[i])).format('yyyy-MM-dd hh:mm:ss') : '--'
					if(isNaN(parseFloat((vl[i]))) || isnull(parseFloat((vl[i])))) {
						text = "- -"
					}
					map[item] = {
						value,
						text,
						time,
						deviceState
					}
				}
				return map
			},
			variableState() {
				return variableName => {
					var value = this.realTimeValueMap[variableName]
					if(value == undefined || value.value == undefined || value.deviceState == -1) {
						//离线或者未获取到
						return -1
					}
					if('0123456789'.includes(value.text.indexOf(0))) {
						//数值显示的文字不是文字，说明是正常的
						return 1
					} else {
						//显示的文字不是数字，说明是告警中
						return 0
					}
				}
			},
			getDeviceState() {
				return deviceNo => {
					var list = []
					var group = this.getVariableTree(deviceNo)
					for(var i1 = 0, len1 = group.length; i1 < len1; i1++) {
						list.addAll(group[i1].next)
					}
					//如果所有变量状态都为正常就是绿，都是离线就离线，有一个越限就越限
					var state = -1
					for(var i = 0, len = list.length; i < len; i++) {
						var variableState = this.variableState(list[i].fromName)
						if(variableState == 0) {
							//有一个越限就是越限
							state = 0
							break
						} else if(variableState != -1) {
							state = 1
						}
					}
					switch(state) {
						case -1:
							return {
								background: 'darkgray'
							}
						case 0:
							return {
								background: '#FF9900'
							}
						case 1:
							return {
								background: '#67C23A'
							}
					}
				}
			},
			getVariableStyle() {
				return variableName => {
					var sty = {
						padding: '5px'
					}
					switch(this.variableState(variableName)) {
						case -1:
							sty.color = 'darkgray'
							break
						case 0:
							sty.color = '#FF9900'
							break
						case 1:
							sty.color = '#67C23A'
							break
					}
					return sty
				}
			},
			nowVariableGroup() {
				return this.getVariableTree(this.nowDevice.no)
			},
			getVariableText() {
				return variableName => {
					var value = this.realTimeValueMap[variableName]
					if(value == undefined) {
						return '- -'
					}
					switch(this.variableState(variableName)) {
						case -1:
							return '- -'
						case 0:
							return value.text + ' ( ' + value.value + ')'
						case 1:
							return value.text
					}
				}
			},
			nowVariableNames() {
				//当前应该显示的变量fromname列表
				if(this.nowType == undefined || isempty(this.nowType.next)) {
					return []
				}
				var v2 = []
				this.nowType.next.forEach(item => {
					this.from2name[item.fromName] = item.name
					v2.push(item.fromName)
				})
				return v2
			},
			nowShowData() {
				//当前应该显示的数据源
				var dataList = this.historyDataList.filter(item => this.nowVariableNames.includes(item.variablename))
				var start = new Date(getDay(0) + ' 00:00:00').getTime()
				var series = []
				for(var i = 0, len = dataList.length; i < len; i++) {
					var item = dataList[i]
					series.push({
						name: this.from2name[item.variablename].subByFirstChar('.'),
						type: 'line',
						smooth: true,
						symbol: 'emptyCircle',
						symbolSize: 5,
						sampling: 'average',
						data: item.data.map((item, index) => {
							return [start + index * 5 * 60 * 1000, item]
						})
					})
				}
				return series
			}
		},
		watch: {
			nowReadDeviceNoList(nv, ov) {
				this.searchDeviceList()
			},
			nowAllVariableNames(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov)
				this.realTimeValueStore.commit("addKeys", nv)
			},
			nowDevice(nv, ov) {
				this.searchTodayHistory()
			},
			nowVariableGroup(nv, ov) {
				if(!isempty(nv)) {
					this.nowType = nv[0]
				} else {
					this.nowType = {}
				}
			},
			nowCheck(nv, ov) {
				if(nv == 1) {
					if(!isempty(this.focusDeviceList)) {
						this.nowDevice = this.focusDeviceList[0]
					} else {
						this.nowDevice = {}
					}
				} else {
					if(!isempty(this.deviceList)) {
						this.nowDevice = this.deviceList[0]
					} else {
						this.nowDevice = {}
					}
				}
				this.historyDataList = []
			},
			focusDeviceList(nv, ov) {
				if(this.nowCheck == 1) {
					if(!isempty(nv)) {
						this.nowDevice = nv[0]
					} else {
						this.nowDevice = {}
					}
				}
			},
			nowShowData(nv, ov) {
				//刷新曲线图
				var chart = this.$refs.vchart
				var options = chart.getOptions()

				options.series = nv
				var selectLegend = {}
				options.legend.data = nv.map((item, index) => {
					selectLegend[item.name] = index < 10
					return item.name
				})

				options.title.textStyle = {
					color: '#fff'
				}
				options.title.top=10
				options.legend.selected = selectLegend
				options.dataZoom[0].start = 0
				options.dataZoom[0].end = 10
				options.dataZoom[1].start = 0
				options.dataZoom[1].end = 10
				if(isempty(this.nowDevice.name)) {
					options.title.text = '请选择设备'
				} else {
					options.title.text = this.nowDevice.name + '今日数据'
				}

				chart.setData(options, true)
			}
		},
		methods: {
			getDeviceListByDeviceNos(deviceNoList) {
				var list = []
				for(var i = 0, len = deviceNoList.length; i < len; i++) {
					var deviceNo = deviceNoList[i]
					//不在当前单位下的不显示
					if(!this.nowReadDeviceNoList.includes(deviceNo)) {
						continue
					}
					var device = this.$store.deviceStore.state.deviceNoToDevice['no' + deviceNo]
					//如果不在可查看设备树中则无法看到
					if(isempty(device)) {
						continue
					}
					list.push(device)
				}
				return list
			},
			searchDeviceList() {
				if(isempty(this.nowReadDeviceNoList)) {
					this.deviceList = []
					return
				}
				//查询最近3天内产生过事件的设备列表
				var bgTime = new Date(getDay(-2) + ' 00:00:00').getTime()
				var endTime = new Date(getDay(1) + ' 00:00:00').getTime()
				this.$api.deviceApi.getVirtualDeviceStateByDeviceNo(this.nowReadDeviceNoList.join(','), bgTime, endTime, respon => {
					var needShowList = []
					eachObject(respon, (value, key) => {
						if(value == 2) {
							needShowList.push(parseInt(key))
						}
					})
					this.deviceList = this.getDeviceListByDeviceNos(needShowList)
					// 获取数据完毕开始自动播放
					this.carouselStart()
				}, err)
			},
			searchRel() {
				this.$api.userRelDevice.searchRel(undefined, "Focus", 1, 1000, respon => {
					this.focusDeviceList = this.getDeviceListByDeviceNos(respon.map(item => item.deviceNo))
				})
			},
			removeDevice(item) {
				this.$api.userRelDevice.removeRel(undefined, "Focus", item.no, respon => {
					this.searchRel()
				})
			},
			addFocus() {
				this.$dialogMethod.openMultipleSelectionDialog('请选择设备', [this.readDeviceTree], undefined,
					respon => {
						var deviceList = respon.filter(item => item.entityName == "VirtualDevicePojo")
						this.$api.userRelDevice.addRel(undefined, "Focus", deviceList.map(item => item.no).join(','), respon => {
							this.searchRel()
						})
					})
			},
			initChart() {
				//初始化图表
				this.options = this.$refs.vchart.getDefaultOptions()
				this.options.grid = {
					left: '1%',
					right: '1%',
					bottom: '18%',
					containLabel: true
				}
				this.options.xAxis = {
					type: 'time',
					splitLine: {
						show: false,
						lineStyle: {
							width: .5,
							type: 'solid'
						},
					},
					axisLabel: {
						formatter: '{value}',
						textStyle: { //改变刻度字体样式
							color: '#fff'
						}
					}
				}
				this.options.yAxis = {
					lineStyle: {
						show: false,
						width: 1,
						type: 'solid',
					},
					axisLabel: {
						formatter: '{value}',
						textStyle: { //改变刻度字体样式
							color: '#fff'
						}
					}
				}
				this.options.dataZoom = [{
						type: 'slider',
						show: true,
						start: 0,
						end: 100,
						handleSize: 8
					},
					{
						type: 'inside',
						start: 0,
						end: 100
					}
				]
				this.$refs.vchart.setData(this.options, true)
			},
			searchTodayHistory() {
				if(isempty(this.nowDevice.no)) {
					this.historyDataList = []
					return
				}
				this.$api.historyApi.searchDeviceHistory(this.nowDevice.no, new Date(getDay(0) + ' 00:00:00').getTime(), Date.now(),
					respon => {
						var dataList = respon[0].next[0].next[0].next
						var resultList = []
						for(var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							resultList.push(item.next[0])
						}
						this.historyDataList = resultList
					})
			},
			nowCheckChange(i) {
				this.nowCheck = i
				removeTask('carouselTimer')
				this.carouselStart()
			},
			carouselStart() {
				var move = document.getElementById('carouselContainer')
				move.scrollLeft = 0
				var width = move.clientWidth
				var wid = 324
				var screenNum = Math.floor(width / wid) // 一屏幕显示的个数
				if(this.nowCheck == 0) {
					var len = this.deviceList.length
					if(len < screenNum) {
						return
					}
					var maxScrollWidth = len * wid - 24 - width
					var scrollWidth = 0
				} else if(this.nowCheck == 1) {
					var len = this.focusDeviceList.length
					if(len < screenNum) {
						return
					}
					var maxScrollWidth = len * wid - 24 - width
					var scrollWidth = 0
				}
				addNewTask('carouselTimer', 20000, 20000, -1, () => {
					if(scrollWidth >= maxScrollWidth) {
						scrollWidth = 0
					} else {
						var count = scrollWidth + wid * screenNum
						if(count >= maxScrollWidth) {
							scrollWidth = maxScrollWidth
						} else {
							scrollWidth = count
						}
					}
					move.scrollLeft = scrollWidth
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../../components/css/usePowerUnit.css");
	.deviceLineBox {
		overflow-x: auto;
		overflow-y: hidden;
		white-space: nowrap;
	}
	
	.powerBoxLi {
		display: inline-block;
		width: 300px;
		margin-right: 24px;
		height: 270px;
		cursor: pointer;
	}
	
	.powerBoxLi:last-child {
		margin-right: 0;
	}
	
	.colorCircle {
		width: 16px;
		height: 16px;
		border-radius: 50%;
		position: absolute;
		right: 37px;
		top: 7px;
	}
	
	.removeDevice {
		width: 20px;
		height: 20px;
		position: absolute;
		right: 7px;
		top: 4px;
		cursor: pointer;
	}
	
	.powerLabel {
		float: left;
	}
	
	.powerTemp {
		float: right;
		color: #0099FF;
	}
	
	.device-type {
		border-radius: 0 5px 0 0;
		margin-right: 2px;
		margin-top: 2px;
		display: inline-block;
		cursor: pointer;
	}
	
	.device-type.uncheck {
		background: dimgrey;
	}
	
	.powerBoxTemp {
		height: calc(100% - 25px);
	}
	
	.variable-group {
		padding: 5px;
		background: rgba(255, 255, 255, 0.1);
	}
</style>